import {
  GET,
  FORSUBMIT,
  UPDATE,
  CLEAR,
  CREATE_CHANGE_REQUEST,
  CONFIRM_CHANGE,
  REJECT_CHANGE,
  ACCEPT_CHANGE_RESPONSE,
  REJECT_CHANGE_RESPONSE,
  CHANGE_RESPONSE,
  CONFIRM,
  CONFIRM_REJECT,
  ACCEPT_RESPONSE,
  REJECT_RESPONSE,
  CALCULATE_BY_DAYS,
  CLEAR_COSTS,
  CREATE_CANCELLATION_REQUEST,
  CONFIRM_CANCELLATION,
  REJECT_CANCELLATION,
  CONFIRM_CANCELLATION_COSTS
} from '@hobs/constants/tickets';
import { actionCreator } from './utils/utils';

export const getForSubmit = () => actionCreator('Ticket/ForSubmit', FORSUBMIT);

export const getTickets = serviceRequestId =>
  actionCreator(`Ticket/${serviceRequestId}`, GET);

export const assign = (ticketId, userId) =>
  actionCreator(`Ticket/Assign/${ticketId}/${userId}`, UPDATE, {
    method: 'POST'
  });

export const clearTickets = () => {
  return dispatch => {
    dispatch({ type: CLEAR.SUCCESS });
  };
};

export const createConfirm = (serviceRequestId, body) =>
  actionCreator(`Ticket/NewAdditional/Confirm/${serviceRequestId}`, CONFIRM, {
    body: body,
    method: 'POST'
  });

export const createConfirmReject = (serviceRequestId, body) =>
  actionCreator(
    `Ticket/NewAdditional/Reject/${serviceRequestId}`,
    CONFIRM_REJECT,
    {
      body: body,
      method: 'POST'
    }
  );

export const createAcceptResponse = serviceRequestId =>
  actionCreator(
    `Ticket/NewAdditional/AcceptConfirmed/${serviceRequestId}`,
    ACCEPT_RESPONSE,
    {
      method: 'POST'
    }
  );

export const createRejectResponse = serviceRequestId =>
  actionCreator(
    `Ticket/NewAdditional/RejectConfirmed/${serviceRequestId}`,
    REJECT_RESPONSE,
    {
      method: 'POST'
    }
  );

export const createChangeRequest = (serviceRequestId, body) =>
  actionCreator(
    `Ticket/ChangeRequest/${serviceRequestId}`,
    CREATE_CHANGE_REQUEST,
    {
      body: body,
      method: 'POST'
    }
  );

export const changeRequestConfirm = (serviceRequestId, body) =>
  actionCreator(
    `Ticket/ChangeRequest/Confirm/${serviceRequestId}`,
    CONFIRM_CHANGE,
    {
      body: body,
      method: 'POST'
    }
  );

export const changeRequestResponse = (serviceRequestId, body) =>
  actionCreator(
    `Ticket/ChangeRequest/Response/${serviceRequestId}`,
    CHANGE_RESPONSE,
    {
      body: body,
      method: 'PUT'
    }
  );

export const changeRequestConfirmReject = (serviceRequestId, body) =>
  actionCreator(
    `Ticket/ChangeRequest/Reject/${serviceRequestId}`,
    REJECT_CHANGE,
    {
      body: body,
      method: 'POST'
    }
  );

export const changeRequestAcceptResponse = serviceRequestId =>
  actionCreator(
    `Ticket/ChangeRequest/AcceptConfirmed/${serviceRequestId}`,
    ACCEPT_CHANGE_RESPONSE,
    {
      method: 'POST'
    }
  );

export const changeRequestRejectResponse = serviceRequestId =>
  actionCreator(
    `Ticket/ChangeRequest/RejectConfirmed/${serviceRequestId}`,
    REJECT_CHANGE_RESPONSE,
    {
      method: 'POST'
    }
  );

export const calculateByDays = body =>
  actionCreator('ServiceRequests/CalculateByDays', CALCULATE_BY_DAYS, {
    body: body,
    method: 'POST'
  });

export function clearCalculateByDays() {
  return dispatch => {
    dispatch({ type: CLEAR_COSTS.SUCCESS });
  };
}

export const createCancellationRequest = (serviceRequestId, body) =>
  actionCreator(
    `Ticket/Cancellation/${serviceRequestId}`,
    CREATE_CANCELLATION_REQUEST,
    {
      body: body,
      method: 'POST'
    }
  );

export const cancellationRequestConfirm = (serviceRequestId, body) =>
  actionCreator(
    `Ticket/Cancellation/Confirm/${serviceRequestId}`,
    CONFIRM_CANCELLATION,
    {
      body: body,
      method: 'POST'
    }
  );

export const cancellationRequestConfirmReject = (serviceRequestId, body) =>
  actionCreator(
    `Ticket/Cancellation/Reject/${serviceRequestId}`,
    REJECT_CANCELLATION,
    {
      body: body,
      method: 'POST'
    }
  );

export const cancellationCostsConfirm = (body) =>
  actionCreator(
  `AssignmentServiceRequest/Cancellation`,
  CONFIRM_CANCELLATION_COSTS,
  {
    body: body,
    method: 'PUT'
  }
);

export const cancellationCostsFinalize = (serviceRequestId) =>
  actionCreator(
  `AssignmentServiceRequest/Cancellation/FinalizeCancellation/${serviceRequestId}`,
  CONFIRM_CANCELLATION_COSTS,
  {
    method: 'PUT'
  }
);
